export const tagFactory = (tag: string) => (name: string) =>
  tag ? `${tag}<${name}>` : name

export const TagFactory = {
  Endofunctor: tagFactory('Endofunctor'),
  Id: tagFactory(''),
}
